/* RB-PDP-MOBILE-ACCORDIONS-V1 | Move native description/specification disclosures above shipping on mobile. */
(() => {
  if (window.RBPdpMobileAccordions) {
    window.RBPdpMobileAccordions.sync();
    return;
  }
  const media = window.matchMedia('(max-width: 768.98px)');
  const origins = new Map();
  let queued = false;

  const sync = () => {
    for (const [node, origin] of origins) {
      if (!origin.isConnected || !node.isConnected) {
        if (node.isConnected && !origin.isConnected) node.remove();
        origins.delete(node);
      }
    }
    const anchor = document.querySelector('[data-rb-pdp-details-anchor]');
    document.querySelectorAll('[data-rb-pdp-mobile-details]').forEach((node) => {
      if (!origins.has(node)) {
        const origin = document.createComment('Mobile product details original position');
        node.before(origin);
        origins.set(node, origin);
      }
      const origin = origins.get(node);
      if (media.matches && anchor && anchor.parentNode) {
        if (node.nextSibling !== anchor) anchor.before(node);
      } else if (origin && origin.parentNode && node.previousSibling !== origin) {
        origin.after(node);
      }
    });
  };

  const scheduleSync = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      sync();
    });
  };

  window.RBPdpMobileAccordions = { sync: scheduleSync };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
  if (media.addEventListener) media.addEventListener('change', scheduleSync);
  else if (media.addListener) media.addListener(scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:unload', scheduleSync);
})();
